import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { portalDelete } from 'store/modules/portals_manager_store/actions';
import { PortalsManagerState } from 'store/modules/portals_manager_store/types';
import createTrack from 'services/actions/tracker_actions';
import { ProfileState } from 'store/modules/profile_store/types';
import companyId from 'services/company_id';
import SquareLoader from '../square_loader';

interface PortalDeleteModalProps {
  showModal: boolean;
  setShowModalDelete: React.Dispatch<React.SetStateAction<boolean>>;
  id: number | undefined;
  name: string | undefined;
}

const PortalDeleteModal = (props: PortalDeleteModalProps) => {
  const { showModal, setShowModalDelete, id, name } = props;
  const dispatch = useDispatch();
  const { request } = useSelector<ApplicationState, PortalsManagerState>(
    (state) => state.session.portals_manager,
  );
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const handleClick = () => {
    dispatch(portalDelete(Number(id), companyId(profile)));
    setShowModalDelete(false);
    createTrack('Gerenciar Portais - Deletou um acesso salvo');
  };

  return (
    <Modal show={showModal}>
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Deletar</h5>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={() => setShowModalDelete(false)}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <p>{`Você tem certeza de que quer deletar ${name}? Essa ação não pode ser desfeita.`}</p>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            data-dismiss="modal"
            onClick={() => setShowModalDelete(false)}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={() => handleClick()}
            disabled={request?.delete_portal?.loading}
          >
            {request?.delete_portal?.loading && <SquareLoader customClass="delete-word" />}
            {!request?.delete_portal?.loading && 'Deletar'}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default PortalDeleteModal;
